module.exports = __webpack_public_path__ + "img/dosing-pills.b921ed2f.svg";